export enum ApplicationSelection {
    ALL_REGIONS = 'all-regions',
    COUCHE_TARD = 'couche-tard',
    CIRCLE_K = 'circle-k',
}

export enum ApplicationTargetEnum {
    QC = 'QC',
    CA = 'CA',
}

export type AppTarget = ApplicationTargetEnum[keyof ApplicationTargetEnum];

export const SELECTED_APPLICATION_STORAGE_KEY = 'selected-application';

export enum ClientProvinceEnum {
    AB = 'AB',
    BC = 'BC',
    MB = 'MB',
    NB = 'NB',
    NL = 'NL',
    NS = 'NS',
    NT = 'NT',
    NU = 'NU',
    ON = 'ON',
    PE = 'PE',
    QC = 'QC',
    SK = 'SK',
    YT = 'YT',
}

export const COUCHE_TARD_PROVINCES = [ClientProvinceEnum.QC];
export const CIRCLE_K_PROVINCES = [
    ClientProvinceEnum.AB,
    ClientProvinceEnum.BC,
    ClientProvinceEnum.MB,
    ClientProvinceEnum.NB,
    ClientProvinceEnum.NL,
    ClientProvinceEnum.NS,
    ClientProvinceEnum.NT,
    ClientProvinceEnum.NU,
    ClientProvinceEnum.ON,
    ClientProvinceEnum.PE,
    ClientProvinceEnum.SK,
    ClientProvinceEnum.YT,
];
export const ALL_PROVINCES = [...CIRCLE_K_PROVINCES, ...COUCHE_TARD_PROVINCES];
